import styled from "styled-components";
import ReactTooltip from 'react-tooltip';
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";
import { formatDatetime, getTsDate } from "../../../utils";
import useModal from "../../../customHooks/useModal";
import ModalConfirm from "./ModalConfirm";
import { useMemo, useState } from "react";
import { ProcedureLog } from ".";
import _ from "lodash";
import moment from "moment";

export interface Procedure {
    route: string;
    name: string;
    icon: string;
    description: string;
}

const proceduresArray: Array<Procedure> = [{
    route: 'cewr2-rack-cleanup',
    name: 'CEWR2 Rack Cleanup',
    icon: 'fa-duotone fa-solid fa-shelves',
    description: `Mark LOCATED data up to ${moment().subtract(3, 'd').format('YYYY-MM-DD')} as DELETED (in specific locations)`
}, {
    route: 'cewr2-rack-cleanup-all',
    name: 'CEWR2 Rack Cleanup All',
    icon: 'fa-duotone fa-solid fa-shelves',
    description: `Mark ALL LOCATED data up to ${moment().subtract(5, 'd').format('YYYY-MM-DD')} as DELETED`
}];

//spCewr2RackCleanupAll

export default function Main({
    data,
    mutate
}: {
    data: Array<ProcedureLog>
    mutate: () => void;
}) {

    const { user } = useUser();
    const { modal, setModal } = useModal();
    const [loading, setLoading] = useState(false);
    const [procedureIndex, setProcedureIndex] = useState<number>(0);

    const latestRunsMap = useMemo(() => {
        const sortedData = _.cloneDeep(data).sort((a, b) => +b.id - +a.id);
        const map: Record<string, string> = {};

        let count = 0;
        for (const { name } of proceduresArray) {
            map[name] = '';
            count++;
        }

        for (const { name, date } of sortedData) {
            if (map[name] === '') {
                map[name] = date;
                count--;
            }
            if (count === 0) {
                break;
            }
        }

        return map;
    }, [data]);

    const handleRunProcedure = async () => {
        const procedure = proceduresArray[procedureIndex];
        if (!procedure) return;

        try {
            setLoading(true);
            await apiClient.post(`/procedures/${procedure.route}`, {
                name: procedure.name,
                runBy: user.s_email,
                date: getTsDate()
            });
            mutate();
            setModal(false);
            setProcedureIndex(undefined);
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    const handleSelectProcedure = (procedureIndex: number) => {
        setProcedureIndex(procedureIndex);
        setModal(true);
    }

    return (
        <div>
            <ReactTooltip />
            {
                proceduresArray.map((item, i) => (
                    <Button 
                        key={i}
                        onClick={() => handleSelectProcedure(i)}
                        className={'my-2'}
                    >
                        <ButtonText>
                            {item.name}
                            <InfoIcon 
                                className={'fas fa-circle-info'} 
                                data-tip={item.description}
                            />
                        </ButtonText>
                        <ButtonIcon className={item.icon} />
                        <LastRunText>
                            Last Run:{' '}  
                            {latestRunsMap[item.name] ? formatDatetime(latestRunsMap[item.name]) : ''}
                        </LastRunText>
                    </Button>
                ))
            }
            <ModalConfirm 
                modal={modal}
                setModal={setModal}
                procedure={proceduresArray[procedureIndex]}
                handleRunProcedure={handleRunProcedure}
                loading={loading}
            />
        </div>
    );
}

const Button = styled.div`
    height: 200px;
    width: 400px;
    background-color: #28a745;
    border-radius: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    &:hover {
        cursor: pointer;
    }
`;

const ButtonText = styled.h1`
    color: white;
`;

const InfoIcon = styled.i`
    font-size: 25px;
    margin-left: 5px;
`;

const ButtonIcon = styled.i`
    font-size: 50px;
    color: white;
`;

const LastRunText = styled.i`
    font-size: 20px;
    color: white;
    margin-top: 10px;
`;